export default {
  ImportValidate: 'import_validate_{0}.xlsx',
  TemplateImportBasic: 'template_basic_{0}.xlsx',
  TemplateImportFull: 'template_full_{0}.xlsx',
  ExportExcel: 'export_{0}.xlsx',
  ExportXml: 'export_{0}.xml',
  ExportJson: 'export_{0}.json',
  ExportMergeReport: 'export_{0}.xlsx',
  PreviewMergeReport: 'export_{0}.pdf',
};